import {put, take, call, fork} from 'redux-saga/effects'
import {get, post} from '../fetch/fetch'
import {actionsTypes as IndexActionTypes} from '../reducers'
import {actionTypes as NewsActionTypes} from '../reducers/newsReducer'

export function* getLatestNews() {
    yield put({type: IndexActionTypes.FETCH_START});
    try {
        return yield call(get, '/api/4/news/latest')
    } catch (error) {
        yield put({type:IndexActionTypes.SET_MESSAGE,msgContent:'获取信息失败',msgType:0});
    } finally {
        yield put({type: IndexActionTypes.FETCH_END});
    }
}

export function* getLatestNewsFlow () {
    while (true){
        let req = yield take(NewsActionTypes.GET_NEWS_LIST);
        let res = yield call(getLatestNews);
        if(res){
            if(res.stories != null){
                /*console.log('NewsActionTypes'+NewsActionTypes.RESPONSE_NEWS_LIST)
                console.log('data:'+res.stories)
                console.log('total:'+{type: NewsActionTypes.RESPONSE_NEWS_LIST,data:res.stories})*/
                yield put({type: NewsActionTypes.RESPONSE_NEWS_LIST,data:res.stories});
            }else{
                yield put({type: IndexActionTypes.SET_MESSAGE, msgContent: res.message, msgType: 0});
            }
        }
    }
}

export function* getNewsDetail(id) {
    yield put({type: IndexActionTypes.FETCH_START});
    try {
        return yield call(get, '/api/4/news/' + id)
    } catch (error) {
        yield put({type:IndexActionTypes.SET_MESSAGE,msgContent:'获取信息失败',msgType:0});
    } finally {
        yield put({type: IndexActionTypes.FETCH_END});
    }
}

export function* getNewsDetailFlow () {
    while (true){
        let req = yield take(NewsActionTypes.GET_NEWS_DETAIL);
        let res = yield call(getNewsDetail,req.id);
        if(res){
            if(res.id != null){
                yield put({type: NewsActionTypes.RESPONSE_NEWS_DETAIL,data:res});
            }else{
                yield put({type: IndexActionTypes.SET_MESSAGE, msgContent: res.message, msgType: 0});
            }
        }
    }
}

export function* getThemes() {
    yield put({type: IndexActionTypes.FETCH_START});
    try {
        return yield call(get, '/api/4/themes')
    } catch (error) {
        yield put({type:IndexActionTypes.SET_MESSAGE,msgContent:'获取信息失败',msgType:0});
    } finally {
        yield put({type: IndexActionTypes.FETCH_END});
    }
}

export function* getThemesFlow () {
    while (true){
        let req = yield take(NewsActionTypes.GET_THEMES_LIST);
        let res = yield call(getThemes);
        if(res){
            if(res.others != null){
                yield put({type: NewsActionTypes.RESPONSE_THEMES_LIST,data:res.others});
            }else{
                yield put({type: IndexActionTypes.SET_MESSAGE, msgContent: res.message, msgType: 0});
            }
        }
    }
}

export function* getThemesDetail(id) {
    yield put({type: IndexActionTypes.FETCH_START});
    try {
        return yield call(get, '/api/4/theme/' + id)
    } catch (error) {
        yield put({type:IndexActionTypes.SET_MESSAGE,msgContent:'获取信息失败',msgType:0});
    } finally {
        yield put({type: IndexActionTypes.FETCH_END});
    }
}

export function* getThemesDetailFlow () {
    while (true){
        let req = yield take(NewsActionTypes.GET_THEMES_DETAIL);
        let res = yield call(getThemesDetail,req.id);
        if(res){
            if(res.stories != null){
                yield put({type: NewsActionTypes.RESPONSE_THEMES_DETAIL,data:res.stories});
            }else{
                yield put({type: IndexActionTypes.SET_MESSAGE, msgContent: res.message, msgType: 0});
            }
        }
    }
}




// WEBPACK FOOTER //
// ./src/sagas/zhihuSaga.js